import React from 'react';
import { useSearchParams } from 'react-router-dom';
import RetencaoBoard from './RetencaoBoard';
import RetencaoMarcacaoBoard from './RetencaoMarcacaoBoard';

/** Reposição — clientes CCC ou marcações (deep link com ?marcacao=). */
const RetencaoPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const marcacao = searchParams.get('marcacao')?.trim();
  if (marcacao) return <RetencaoMarcacaoBoard />;
  return <RetencaoBoard />;
};

export default RetencaoPage;
